import { Component, ElementRef, ViewChild, ViewEncapsulation, AfterViewInit, HostListener, OnInit, NgZone, Input  } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { StateService } from '../../services/history.state.service';
import { CommmonUtil } from '../utils/common.util';
import { SMSservice } from '../../../../core/services/sms.service';
import { environment } from '../../../../../environments/environment';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs'; 
import { CommonMessageService } from '../../../../services/messageCountService';
import { NavigationService } from '../../../../services/navigationPath';
import { ProfileService } from '../../../../services/profile.service';
import { PatientEngagementService } from '../../services/patient-engagement.service';
import { PeAuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'my-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit{
  @ViewChild('menuIcon', { static: true }) menuIcon!: ElementRef;   
  @ViewChild('popupMenu', { static: true }) popupMenu!: ElementRef;
  @ViewChild('backdrop', { static: true }) backdrop!: ElementRef;
  @ViewChild('breadcrumbs', { static: true }) breadcrumbs!: ElementRef;
  profileImage: any;
  patientProfileData: any = [];
  avatarUrl = '/assets/images/dp_pic.png';
  @Input()
  set ProfileImage(pi: any) {
      this.profileImage = pi;
  }
  activeSection: string = '';
  unreadMsgCounts:any;
  private needScroll = false;
  isSecurePatientComm!:boolean;
  currentPath:any;
  pharmacyName:any;
  imageUrl:any;
  elinkParams:any;
  npi :any;
  pharmacyInfo:any;
  isActiveScreen!:boolean;
  private unsubscribe$ = new Subject<void>();
  isOnline = true;
   private destroy$ = new Subject<void>();
isProfileMenuOpen = false;
  
  constructor(
    private _authService: AuthService,
    private _router: Router,
    private stateService: StateService,
    private commmonUtil:CommmonUtil,
    private commonMessageService:CommonMessageService,
      public peAuthService: PeAuthService,
    private patientEngagementService: PatientEngagementService,
    private navigationService: NavigationService,
    private smsService:SMSservice, 
    private _profileSvc : ProfileService) {
      this.checkConnectivity();
      this.stateService.activeSection$.subscribe(section => {
        this.activeSection = section;
        this.needScroll = true;
      });
    }
  ngOnInit(): void {
    this._profileSvc.profileImage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(url => (this.avatarUrl = url));
    this.isSecurePatientComm = environment.isSecurePatientComm;
    this.navigationService.currentPath$.subscribe(path => {
      this.currentPath = path;
    });
    if(this.isSecurePatientComm){
      this.commonMessageService.unreadCount$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((count) => {
          this.unreadMsgCounts = count;
        });
    }
    const cached = localStorage.getItem("avatarUrl");
    if (!cached) {
      this.loadProfilePicture();
    }
    else{
      this.avatarUrl=cached;
    }
  this._router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      this.currentPath = event.urlAfterRedirects.replace('/', '');
    }
  });
  }

  
private async loadProfilePicture() {
  try {
    console.log("loadProfilePicture: started");

    // 1. Get patient profile data
    const data = await this.smsService.getPatientProfile();

    if (!data) {
      console.warn("loadProfilePicture: No profile data found");
      return;
    }

    // 2. Load pharmacy info from local storage
    this.pharmacyInfo = JSON.parse(localStorage.getItem('PharmacyInfo') as string);
    if (this.pharmacyInfo) {
      this.pharmacyName = this.pharmacyInfo?.name;
    }
    console.log("loadProfilePicture: pharmacyName:", this.pharmacyName);

    // 3. Load params data from local storage
    this.elinkParams = JSON.parse(localStorage.getItem('paramsData') as string);
    this.npi = this.elinkParams?.npi;
    console.log("loadProfilePicture: npi:", this.npi);

    // 4. Get gender for fallback use
    const gender = data?.patientInfo?.gender?.toLowerCase();
    console.log("loadProfilePicture: gender:", gender);

    // 5. Check if profilePictureId exists and is not just empty spaces
    const profilePictureId = data?.patientInfo?.profilePictureId?.trim();
    if (profilePictureId) {
      // Prepare download payload
      const payload={
        profilePictureId: profilePictureId,
        npi: this.npi,
        pharmacyName: this.pharmacyName,
        patientid: data?.patientInfo?.patientId,
        fullname: data?.patientInfo?.fullName
      }
      this.imageUrl=await this.patientEngagementService.getProfilePictureUrl(payload);
      // 8. Set image or fallback
      if (this.imageUrl) {
        this._profileSvc.setImage(this.imageUrl);
      } else {
        const fallback =
          gender === 'male'   ? '/assets/images/male_pic.png'   :
          gender === 'female' ? '/assets/images/female_pic.png' :
                                '/assets/images/dp_pic.png';
        this._profileSvc.setImage(fallback);
        console.warn("loadProfilePicture: No profile image found, set fallback:", fallback);
      }
    } else {
      // No profilePictureId, set fallback
      const fallback =
        gender === 'male'   ? '/assets/images/male_pic.png'   :
        gender === 'female' ? '/assets/images/female_pic.png' :
                              '/assets/images/dp_pic.png';
      this._profileSvc.setImage(fallback);
      console.warn("loadProfilePicture: profilePictureId missing, set fallback:", fallback);
    }
  } catch (e) {
    console.error("loadProfilePicture: Error occurred:", e);
  }
}



  showSection(section: string) {
      if(section === 'dashboard'){
        this._router.navigate(['/dashboard']);
      } else if(section === 'profile'){
        this._router.navigate(['/profile']);
      } else {
        this.stateService.setActiveSection(section); 
        this._router.navigate(['/PendingPayments']);
      }
      this.closeFilter(); 
  }
  togglePopup() { 
    const popupMenu = this.popupMenu.nativeElement; 
    const backdrop = this.backdrop.nativeElement; 
    const computedStyles = window.getComputedStyle(popupMenu);
    const display = computedStyles.getPropertyValue('display'); 

    if (display === 'none') {
      const icon = this.menuIcon.nativeElement;
      const position = icon.getBoundingClientRect();
      const top = position.bottom + window.scrollY;
      const left = position.left - 15;  

      popupMenu.style.display = 'block';
      popupMenu.style.top = `${top}px`;
      popupMenu.style.left = `${left}px`;
      backdrop.style.display = 'block';
    } else { 
      popupMenu.style.display = 'none';
      backdrop.style.display = 'none';
    }
  }

  ngAfterViewInit() {
    document.addEventListener('click', (event) => this.onClick(event));
    this.needScroll = true;
  }

  ngAfterViewChecked(): void {
    if (this.needScroll) {
      this.scrollActiveButtonIntoView();
      this.needScroll = false; 
    }
  }
  scrollActiveButtonIntoView(): void {
    if (this.breadcrumbs) {
      this.commmonUtil.scrollActiveButtonIntoView(this.breadcrumbs, this.activeSection);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) { 
    if (this.menuIcon?.nativeElement && this.popupMenu?.nativeElement) {
      const icon = this.menuIcon.nativeElement;
      const position = icon.getBoundingClientRect();
      const top = position.bottom + window.scrollY;
      const left = position.left - 15;  

      const popupMenu = this.popupMenu.nativeElement;
      popupMenu.style.top = `${top}px`;
      popupMenu.style.left = `${left}px`;
    }
  }

  onClick(event: MouseEvent) {
    if (this.popupMenu?.nativeElement && this.menuIcon?.nativeElement) {
        const popupMenu = this.popupMenu.nativeElement;
        const backdrop = this.backdrop.nativeElement;
        const menuIcon = this.menuIcon.nativeElement; 
        if (!menuIcon.contains(event.target) && !popupMenu.contains(event.target)) {
          popupMenu.style.display = 'none';
          backdrop.style.display = 'none';
        }
    }
  }
  closeFilter() {
    if(this.popupMenu?.nativeElement){
      const popupMenu = this.popupMenu.nativeElement;
      const backdrop = this.backdrop.nativeElement;
      popupMenu.style.display = 'none';
      backdrop.style.display = 'none';
    }
  }
  openSPC(){
    this._router.navigate(['/spc']);
  }
  async logout() {
    await this.peAuthService.logout();
  }

  @HostListener('window:offline', [])
  onOffline() {
    this.isOnline = false;
  }

  @HostListener('window:online', [])
  onOnline() {
    this.isOnline = true;
  }

  private checkConnectivity() {
    this.isOnline = navigator.onLine;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  toggleProfileMenu(e: MouseEvent) {
      e.stopPropagation();
     this.isProfileMenuOpen = !this.isProfileMenuOpen;
}

  @HostListener('document:click')
  closeOnOutside() {
  this.isProfileMenuOpen = false;
}
}